export const formatNumeric = (rawStr, currencyCode = 'USD') => {
    if (!rawStr) return '';
    try {
        return Intl.NumberFormat('en-US', {
            style: 'currency', 
            currency: currencyCode,
            currencyDisplay: 'code'
        }).format(rawStr).replace(/[a-z]{3}/i, "").trim();
    } catch (e) { /* in case rawStr is invalid */ }
}

export const currencyToSymbol = (currencyCode) => {
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 2,
            currencySign: "accounting"
        })
            .formatToParts(0)
            .find(part => part.type === 'currency')
            .value;
    } catch (e) {
        return currencyCode
    }
}